// extracted by mini-css-extract-plugin
export var container = "PlusUpsell-module__container___eGbOp";
export var tableAndImageContainer = "PlusUpsell-module__tableAndImageContainer___MZTN9";
export var upsellTable = "PlusUpsell-module__upsellTable___tMDHv";
export var logoPlusImage = "PlusUpsell-module__logoPlusImage___rGRRP";
export var texture = "PlusUpsell-module__texture___EW9KV";
export var imageContainer = "PlusUpsell-module__imageContainer___RXp9u";
export var image = "PlusUpsell-module__image___AeaM7";
export var title = "PlusUpsell-module__title___QXLvZ";
export var tableHeader = "PlusUpsell-module__tableHeader___E_DYr";
export var headerRow = "PlusUpsell-module__headerRow___SS82Z";
export var headerRowFeature = "PlusUpsell-module__headerRowFeature___R1LSD";
export var headerRowFreePro = "PlusUpsell-module__headerRowFreePro___KIFxZ";
export var featureRow = "PlusUpsell-module__featureRow___nrDuY";
export var featureRowTint = "PlusUpsell-module__featureRowTint___lRU5Z";
export var featureRowCell = "PlusUpsell-module__featureRowCell___pzdUP";
export var featureRowText = "PlusUpsell-module__featureRowText___uO2Q2";
export var featureRowFree = "PlusUpsell-module__featureRowFree___dWNVs";
export var featureRowPro = "PlusUpsell-module__featureRowPro___uknKY";
export var buyLink = "PlusUpsell-module__buyLink___N00Oa";